<template>
  <Header />
  <div class="home">
    <section class="section">
      <iframe
        src="https://notfound-static.fwebservices.be/en/404?key=61897a970b0f5"
        width="75%"
        height="500"
        frameborder="0"
      ></iframe>
    </section>
  </div>
  <Footer />
  <router-view></router-view>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "NotFound",
  components: {
    Header,
    Footer,
  },
};
</script>
